import React from "react";
import MasterLayout from "../masterLayout/MasterLayout";
import PastExpoGalleryLayer from "../components/PastExpoGalleryLayer";

const PastExpoGalleryPage = () => {
  return (
    <>
      <MasterLayout>
        <PastExpoGalleryLayer />
      </MasterLayout>
    </>
  );
};

export default PastExpoGalleryPage;
